<template>
  <section class="stepsNew">
    <div class="stepsNew__info">
      <h3 class="title">
        {{$t('qic_landing_steps_header1')}} <span> {{$t('qic_landing_steps_header2')}}</span>
      </h3>
      <p>{{$t('qic_landing_steps_desc1')}}
        <a :href="`tel:${$t('qic_landing_steps_desc_phone')}`">{{$t('qic_landing_steps_desc_phone')}}
        </a>
        {{$t('qic_landing_steps_desc2')}}
        <a :href="`https://api.whatsapp.com/send/?phone=${$t('qic_landing_steps_desc_whatsapp')}&text&app_absent=0`">{{$t('qic_landing_steps_desc_whatsapp')}}
        </a>
        {{$t('qic_landing_steps_desc3')}}
      </p>
    </div>
      <LottieAnimation
        class="stepsNew__video"
        ref="anim"
        :animationData="getLinkToAnimation()"
        loop
        autoPlay
        :speed="1"
      />
  </section>
</template>

<script>
export default {
  name: 'LandingStepsToClaim',
  components: {
    LottieAnimation: () => import('lottie-web-vue')
  },
  methods: {
    getLocale () {
      return this.$i18n.locale || 'en'
    },
    getLinkToAnimation () {
      const locale = this.getLocale()
      if (locale === 'en') {
        return require('../../assets/animations/stepsEn.json')
      }
      return require('../../assets/animations/stepsAr.json')
    }
  }
}
</script>

<style lang="scss" scoped>
  .stepsNew__info a{
    color: #000000;
    cursor: pointer;
  }
</style>
